import { PartialTranslation } from '../translations';

export const sl: PartialTranslation = {
  newChat: 'Nov klepet',
  search: 'Iskanje',
  user: 'Uporabnik',
  settings: 'Nastavitve',
  language: 'Jezik',
  getHelp: 'Pridobite pomoč',
  viewAllPlans: 'Oglej si vse načrte',
  learnMore: 'Nauči se več',
  logOut: 'Odjava',
  chooseLanguage: 'Bize lingvon',
  chooseYourPreferredLanguage: 'Bize vian preferatan lingvon',
  searchLanguages: 'Serĉi lingvojn...',
  autoDetect: 'Samodejno zaznavanje',
  noLanguagesFound: 'Neniuj lingvoj trovitaj',
  askAnything: 'Vprašaj karkoli',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Osebno',
  freePlan: 'Brezplačni načrt',
  current: 'Nuna',
  close: 'Fermi',
  archive: 'Arkivigi',
  delete: 'Forigi',
  confirmDelete: 'Ĉu vi certas ke vi volas forigi ĉi tiun babilon?',
  confirmArchive: 'Ĉu vi certas ke vi volas arkivigi ĉi tiun babilon?',
  deleteCannotUndo: 'Ĉi tiu ago ne povas esti malfari.',
  archiveCanFind: 'Vi povas trovi ĝin en la arkiva listo post arkivigo.',
  
  // 资源面板
  resources: 'Viri',
  addResource: 'Dodaj vir',
  deleteResource: 'Forigi rimedon',
  noMatchingResourcesFound: 'Neniuj kongruaj rimedoj trovitaj',
  noResourcesAvailable: 'Neniuj rimedoj disponeblaj',
  hideResources: 'Kaŝi rimedojn',
  showResources: 'Montri rimedojn',
  
  // 聊天输入框
  typeMessage: 'Vnesite sporočilo...',
  thinkingOptions: 'Pensaj opcioj',
  deleteFile: 'Forigi dosieron',
  clearSelection: 'Viŝi selekton',
  addAttachment: 'Dodaj prilogo',
  sendMessage: 'Pošlji sporočilo',
  
  // 思考模式选项
  deepInsight: 'Profunda kompreno · Surfaca analizo',
  deepInsightDesc: 'Rapida kompreno de ŝlosilaj punktoj',
  deepExploration: 'Profunda esplorado · Ampleksa analizo',
  deepExplorationDesc: 'Multdimensia profunda esplorado',
  deepDeconstruction: 'Profunda malkonstruado · Sistema argumento',
  deepDeconstructionDesc: 'Tavolo post tavolo progresa analizo',
  
  // 写作模式选项
  contractReview: 'Kontrakta revizio · Risko identigo',
  contractReviewDesc: 'Klausola analizo kaj konformeca kontrolo',
  textPolish: 'Teksta poluro · Profesia esprimo',
  textPolishDesc: 'Lingva optimumigo kaj struktura alĝustigo',
  legalDocuments: 'Leĝaj dokumentoj · Norma malneto',
  legalDocumentsDesc: 'Profesia leĝa dokumento skribado',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Prijava',
  register: 'Registracija',
  welcomeBack: 'Dobrodošli v LawHelper',
  loginSubtitle: 'Vaš AI asistent za pravne raziskave',
  continueWithGoogle: 'Nadaljuj z Google',
  continueWithMicrosoft: 'Nadaljuj z Microsoft',
  continueWithWeChat: 'Nadaljuj z WeChat',
  orContinueWith: 'ali nadaljuj z',
  emailTab: 'E-pošta',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Vnesite svojo e-pošto',
  phonePlaceholder: 'Vnesite telefonsko številko',
  codePlaceholder: 'Vnesite 6-mestno kodo',
  sending: 'Pošiljanje...',
  verifying: 'Preverjanje...',
  verify: 'Preveri',
  sendMagicLink: 'Pošlji čarobno povezavo',
  getVerificationCode: 'Pridobi kodo',
  resendCode: 'Ponovno pošlji kodo',
  resendIn: 'Ponovno pošlji čez',
  magicLinkSent: 'Čarobna povezava je bila poslana na vašo e-pošto',
  magicLinkHint: 'Poslali vam bomo varno povezavo na vašo e-pošto',
  otpSent: 'Koda za preverjanje je bila poslana',
  agreeToTerms: 'Z nadaljevanjem se strinjate z našimi',
  privacyPolicy: 'Politika zasebnosti',
  termsOfService: 'Pogoji uporabe',
  and: 'in',
  privacyTitle: 'Vaša zasebnost je pomembna',
  privacyIntro: 'Uporabljamo piškotke in podobne tehnologije za zagotavljanje najboljše izkušnje.',
  essentialCookies: 'Nujni piškotki',
  essentialDesc: 'Potrebni za delovanje spletne strani',
  analyticsCookies: 'Analitični piškotki',
  analyticsDesc: 'Pomagajo nam izboljšati storitev',
  marketingCookies: 'Marketinški piškotki',
  marketingDesc: 'Uporabljajo se za personalizirano vsebino',
  acceptAll: 'Sprejmi vse',
  essentialOnly: 'Samo nujni',
  customize: 'Prilagodi',
  savePreferences: 'Shrani nastavitve',
  back: 'Nazaj',
  readPrivacyPolicy: 'Preberite našo politiko zasebnosti',
  cookiePolicy: 'Politika piškotkov',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI pregled',
  aiDraft: 'AI osnutek',
  smartAssistant: 'Predloga',

  // 知识库搜索
  enableKnowledgeSearch: 'Omogoči iskanje',
  knowledgeSearchDesc: 'AI išče v vaših dokumentih',
  clickToDisable: 'Onemogoči',
  clickToEnable: 'Omogoči',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Zapri ploščo virov',
  uploading: 'Nalaganje %{fileName}...',
  processing: 'Obdelava %{fileName}...',
  uploadSuccess: '✓ %{fileName} naloženo',
  uploadError: '✗ Nalaganje neuspešno: %{error}',
  quickAnswer: 'Hitri odgovor',
  quickAnswerDesc: 'Hitri odgovor na preprosta vprašanja',
  cancelRequest: 'Prekliči',
  library: 'Knjižnica',
  filterAll: 'Vse',
  filterChat: 'Pogovori',
  filterReview: 'Pregled',
  filterDraft: 'Osnutek',
  filterTemplate: 'Predloga',
  filterForm: 'Obrazec',
  thinking: 'Razmišljam...',
  thinkingProcess: 'Miselni proces',
  analyzingLegalLogic: 'Analiza pravne logike...',
  lawhelperThinking: 'Lawhelper razmišlja...',
  serviceError: 'Napaka storitve',
  uploaded: 'Naloženo',
  settingsGeneral: 'Splošno',
  settingsNotifications: 'Obvestila',
  settingsAppearance: 'Videz',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Obvestila o odgovorih',
  settingsResponseNotificationsDesc: 'Obvestilo ob zaključku AI odgovora',
  settingsColorMode: 'Barvni način',
  settingsLight: 'Svetlo',
  settingsDark: 'Temno',
  settingsSystem: 'Sistem',
  about: 'O aplikaciji',
  reviewTitle: 'Pregled dokumenta',
  exitReview: 'Zapusti pregled',
  uploadPrompt: 'Naložite PDF za pregled',
  uploadButton: 'Izberi datoteko',
  startChatConfig: 'Napišite "Preglej ta dokument"',
  reviewPlaceholder: 'Vnesite sporočilo...',
  analyzing: 'Pregledovanje...',
  reviewComplete: 'Pregled končan',
  issuesFound: 'Najdenih %{count} težav',
  draftTitle: 'Priprava pravnega dokumenta',
  draftPlaceholder: 'Uredite tukaj ali prosite AI...',
  analyzingTemplate: 'Analiza predloge %{name}...',
  templateAnalyzed: '✅ Predloga %{name} analizirana!',
  templateAnalysisPrompt: 'Analiziraj ključne klavzule',
  parsingFailed: '⚠️ Neuspešna analiza datoteke.',
  generating: 'Generiranje...',
  generatedSuccess: '✅ Dokument generiran!',
  drafterWelcome: 'Dobrodošli v AI asistentu za dokumente',
  drafterYouCan: 'Lahko:',
  drafterUploadTemplate: 'Naložite predlogo za AI analizo',
  drafterDescribeNeeds: 'Opišite zahteve dokumenta',
  drafterLetAiHelp: 'AI pomaga s pogodbami, sporazumi itd.',
  drafterExamples: 'Primeri:',
  drafterExampleRental: '"Pripravite najemno pogodbo"',
  drafterExampleLabor: '"Izpolnite pogodbo o zaposlitvi"',
  drafterInputPlaceholder: 'Opišite potrebe...',
  drafterThinking: 'Razmišljam...',
  drafterHistoryTitle: 'Zgodovina',
  drafterNoHistory: 'Ni zgodovine',
  drafterNewChat: 'Nov pogovor',
  drafterHistory: 'Zgodovina',
  drafterRemoveAttachment: 'Odstrani prilogo',
  drafterLineHeight: 'Višina vrstice',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Izvozi v Word (.docx)',
  drafterExportPdf: 'Izvozi v PDF',
  drafterSave: 'Shrani dokument',
  drafterDownload: 'Prenesi dokument',
  drafterUndo: 'Razveljavi',
  drafterRedo: 'Ponovi',
  drafterBold: 'Krepko',
  drafterItalic: 'Ležeče',
  drafterStrike: 'Prečrtano',
  drafterUnderline: 'Podčrtano',
  drafterHighlight: 'Označi',
  drafterLink: 'Vstavi povezavo',
  drafterAlignLeft: 'Levo',
  drafterAlignCenter: 'Sredina',
  drafterAlignRight: 'Desno',
  drafterAlignJustify: 'Obojestransko',
  drafterList: 'Seznam',
  drafterBulletList: 'Označen seznam',
  drafterOrderedList: 'Oštevilčen seznam',
  drafterTaskList: 'Seznam nalog',
  drafterOpenResource: 'Odpri vire',
  drafterStopGeneration: 'Ustavi generiranje',
  drafterAgentMode: 'Agentni način aktiven',
  drafterAgentModeOn: 'Agentni način aktiven',
  drafterAgentModeOff: 'Običajen način',
  drafterUploadAttachment: 'Naloži prilogo',
  drafterExit: 'Izhod',
  drafterConfirm: 'Potrdi',
  drafterOpenLink: 'Odpri povezavo',
  drafterDeleteLink: 'Izbriši povezavo',
  drafterQuote: 'Citat',
  workflowTitle: 'AI potek dela',
  workflowRunning: 'Izvajanje...',
  workflowReady: 'Pripravljen',
  workflowCompleted: 'Končano',
  workflowStartFailed: 'Neuspešen zagon',
  workflowExecutionFailed: 'Neuspešno izvajanje',
  workflowInterrupted: 'Potek dela prekinjen',
  workflowProcessing: 'Obdelava...',
  workflowStepsCompleted: 'korakov končanih',
  workflowStepsTotal: 'Potek dela končan (%{count} korakov)',
  acceptChanges: 'Sprejmi spremembe',
  rejectChanges: 'Zavrni spremembe',
  changesAccepted: 'Spremembe sprejete',
  changesRejected: 'Spremembe zavrnjene',
  stopWorkflow: 'Ustavi',
  restartWorkflow: 'Znova zaženi',
  startDrafting: 'Začni pripravo',
  interrupt: 'Ustavi',
  documentSubject: 'Tema dokumenta *',
  documentType: 'Vrsta dokumenta',
  jurisdiction: 'Pristojnost',
  specialRequirements: 'Posebne zahteve (neobvezno)',
  clickStartDrafting: 'Kliknite "Začni pripravo"',
  docTypeContract: 'Pogodba',
  docTypeAgreement: 'Sporazum',
  docTypeNotice: 'Obvestilo',
  docTypeLetter: 'Pismo',
  docTypePetition: 'Peticija',
  docTypeWill: 'Oporoka',
  docTypePowerOfAttorney: 'Pooblastilo',
  countryChina: 'Kitajska',
  countryUSA: 'ZDA',
  countryGermany: 'Nemčija',
  countryJapan: 'Japonska',
  countryFrance: 'Francija',
  countryUK: 'Združeno kraljestvo',
  citationVerified: 'Preverjeno',
  citationUnverified: 'Nepreverjeno',
  imageLoadFailed: 'Neuspešno nalaganje slike',
  smartDocTitle: 'Pametni asistent',
  smartDocChatTitle: 'AI asistent za dokumente',
  smartDocDropPrompt: 'Spustite PDF tukaj',
  smartDocSelectFile: 'Izberi datoteko',
  smartDocOr: 'ali',
  smartDocWelcomeTitle: 'Dobrodošli v AI asistentu',
  smartDocWelcomeYouCan: 'Lahko:',
  smartDocUploadForAI: 'Naložite predlogo',
  smartDocDescribeDoc: 'Opišite zahteve',
  smartDocLetAIDraft: 'AI pomaga s pogodbami',
  smartDocExamples: 'Primeri:',
  smartDocExampleRental: '"Pripravite najemno pogodbo"',
  smartDocExampleLabor: '"Izpolnite pogodbo o zaposlitvi"',
  smartDocInputPlaceholder: 'Opišite potrebe...',
  smartDocRemoveAttachment: 'Odstrani prilogo',
  smartDocOpenResources: 'Odpri vire',
  smartDocExit: 'Izhod',
  reviewStartFailed: 'Neuspešen zagon pregleda',
  reviewFailed: 'Pregled neuspešen',
  reviewFoundIssues: 'Pregled končan, %{count} težav.',
  cannotReadStream: 'Ni mogoče brati toka',
  parseEventFailed: 'Neuspešna analiza dogodka',
  errorPrefix: 'Napaka',
  unknownError: 'Neznana napaka',
  file: 'Datoteka',
  loading: 'Nalaganje...',
  localFolders: 'Lokalne mape',
  selectLocalFolder: 'Izberi lokalno mapo',
  reselectFolder: 'Zamenjaj mapo',
  addToContext: 'Dodaj v pogovor',
  saveFile: 'Shrani',
  renameFile: 'Preimenuj',
  fileSaved: 'Datoteka shranjena',
  fileRenamed: 'Datoteka preimenovana v %{name}',
  browserNotSupported: 'Brskalnik ne podpira dostopa do map',
  noFolderSelected: 'Izberite lokalno mapo',
  scanningFolder: 'Pregledovanje mape...',
  selectFileToPreview: 'Izberite datoteko za predogled',
  aiAnalyze: 'AI analiza',
};
